import Vue from 'vue';

Vue.filter("nodecimal", v => (v ? v.toFixed(0) : ''));
Vue.filter("onedecimal", v => (v ? v.toFixed(1) : ''));
Vue.filter("twodecimal", v => (v ? v.toFixed(2) : ''));

Vue.filter("nodecimalorline", v => (v ? v.toFixed(0) : '-'));
Vue.filter("salarydecimal", v => (
    v 
        ? 
            Number(v)
                .toFixed(2)
                .replace('.', ',') 
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") 
        : ''
));